import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import logoMark from 'assets/favicon/favicon-96x96.png';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse = false }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box
        component="img"
        src={logoMark}
        alt="Liance"
        sx={{
          width: 34,
          height: 34,
          display: 'block',
          borderRadius: '10px',
          boxShadow: '0 10px 30px rgba(17, 24, 39, 0.06)'
        }}
      />
      <Box>
        <Typography variant="subtitle1" sx={{ color: reverse ? 'common.white' : 'text.primary', lineHeight: 1.1 }}>
          Liance
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: reverse ? 'rgba(255,255,255,0.68)' : 'text.secondary',
            letterSpacing: '0.08em',
            textTransform: 'uppercase'
          }}
        >
          Operator workspace
        </Typography>
      </Box>
    </Box>
  );
}
